import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultDatePickerInput } from "../../../../../../common/components/default_date_picker_input";

type Props = {
  informacoes?: string | null;
  data?: Date | null;
  onInformacoesChange: (v: string) => void;
  onDataChange: (v: Date | null) => void;
  onClear: () => void;
};

export const HeaderResponsavel = ({ informacoes, data, onInformacoesChange, onDataChange, onClear }: Props) => {
  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
          <DefaultInput label="Pesquisar por Informações" name="" value={informacoes ?? ""} onChangeValue={onInformacoesChange} />
         
          <DefaultDatePickerInput label="Data Receber" value={data} onChange={onDataChange} />
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClear}
            >
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
};
